var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBeatmatch = function SvgBeatmatch(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.559,
    height: 158.559,
    viewBox: "0 0 158.559 158.559",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1455",
    "data-name": "Group 1455",
    transform: "translate(16913.75 -1863.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 12.436,
    height: 91.715,
    rx: 6.218,
    transform: "translate(-16840.689 1896.672)",
    fill: "#22282F"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 12.436,
    height: 60.625,
    rx: 6.218,
    transform: "translate(-16814.262 1915.326)",
    fill: "#22282F"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 12.436,
    height: 41.971,
    rx: 6.218,
    transform: "translate(-16867.113 1921.544)",
    fill: "#22282F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    d: "M79.279,9a70.279,70.279,0,1,0,70.279,70.279A70.359,70.359,0,0,0,79.279,9m0-9A79.279,79.279,0,1,1,0,79.279,79.279,79.279,0,0,1,79.279,0Z",
    transform: "translate(-16913.75 1863.25)",
    fill: "#22282F"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBeatmatch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/beatmatch.58f2ecb2e3053a091ef7f4443255488f.svg";